import { Clock, Mail, Phone } from "lucide-react";
import FacebookIcon from "../assets/icons/facebook.svg";
import InstagramIcon from "../assets/icons/instagram.svg";

interface Props {
  showBorder?: boolean;
}
const Footer = (props: Props) => {
  const { showBorder } = props;
  const rootClassName = showBorder
    ? "border-t-2 border-gray-200 mt-8"
    : undefined;

  return (
    <div className={rootClassName}>
      <div className="bg-gray-50 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex">
              <Phone size={24} className="text-red-600" />
              <p className="text-lg font-semibold mb-2 text-center ml-4">
                Sunați-ne
              </p>
            </div>
            <p className="font-semibold">Telefon mecanică & ITP:</p>
            <p>0772006950</p>
            <p className="font-semibold mt-4">
              Telefon tinichigerie & vopsitorie:
            </p>
            <p>0772005574</p>
          </div>
          <div>
            <div className="flex">
              <Mail size={24} className="text-red-600" />
              <p className="text-lg font-semibold mb-2 text-center ml-4">
                Email
              </p>
            </div>
            <p className="font-semibold">Mecanică & ITP:</p>
            <p>gabylenmecanica@gmail.com</p>
            <p className="font-semibold mt-4">Tinichigerie & vopsitorie:</p>
            <p>gabyautoservice@gmail.com</p>
          </div>
          <div>
            <div className="flex">
              <Clock size={24} className="text-red-600" />
              <p className="text-lg font-semibold mb-2 text-center ml-4">
                Program
              </p>
            </div>
            <p className="font-semibold">Luni - Vineri: 09:00 - 17:00</p>
            <div className="flex mt-4 md:mt-6">
              <Clock size={24} className="text-red-600" />
              <p className="text-lg font-semibold mb-2 text-center ml-4">
                Program ITP
              </p>
            </div>
            <p className="font-semibold">Luni - Vineri: 08:00 - 16:00</p>
          </div>
        </div>
      </div>
      <div className="bg-gray-50 py-8 pb-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid md:grid-cols-3 gap-10">
          <div className="justify-center">
            <p className="text-lg font-semibold mb-2">
              Peste 10 ani de experiență
            </p>
            <div className="flex">
              <a
                href="https://www.facebook.com/gabylenautoservice"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <img
                  src={FacebookIcon}
                  className="w-8 h-8"
                  alt="Facebook logo"
                />
              </a>
              <a
                href="https://www.instagram.com/gabylenauto/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <img
                  src={InstagramIcon}
                  className="w-8 h-8 ml-2"
                  alt="Instagram logo"
                />
              </a>
            </div>
          </div>
          <div>
            <p className="text-lg font-semibold mb-2">Servicii</p>
            <ul className="list-disc space-y-1">
              <li>Tinichigerie</li>
              <li>Vopsitorie</li>
              <li>Mecanică auto</li>
              <li>Vulcanizare</li>
              <li>ITP</li>
            </ul>
          </div>
          <div>
            <p className="text-lg font-semibold mb-2">Contactați-ne</p>
            <p>Str. Porii 162 (în capătul străzii), com. Florești, jud. Cluj</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
